export default __webpack_public_path__ + "static/media/grayTick.2dac21c1.svg";